import api from "@/lib/api";

export async function monitoringAtendentes(unidade, setor) {
  const { data } = await api.get("/secretaria-digital/monitoring/atendentes", { params: { unidade, setor } })
  return data
}